export { default } from "./TranscriptViewer";
